// extracted by mini-css-extract-plugin
export default {"button":"src-___button__button___DxhhR","busy-button":"src-___button__busy-button___On7s- src-___button__button___DxhhR"};